import React from 'react';
import PopupEditContact from '../PopupEditContact';
import {EditContactProvider} from '../EditContactContext';
import PopupDeleteRestoreContact from '../PopupDeleteRestoreContact';
import ButtonDD from "../../../_common/components/ButtonDD";

export function ContactsActionsColumnFormatter(cellContent) {
  const {contactID} = cellContent;

  return (
    <div className="d-flex justify-content-end align-items-center">
      <ButtonDD
        items={[{
          itemContent: (
            <div className="d-flex justify-content-between align-items-center">
              <EditContactProvider contactID={contactID}>
                <PopupEditContact/>
              </EditContactProvider>
              <PopupDeleteRestoreContact data={cellContent}/>
            </div>
          )
        }
        ]}
      />
    </div>

  );
}
